import { SubscriptionRoutes } from "..";
import { format } from "date-fns";
import * as React from "react";
import { useHistory } from "react-router-dom";

import { Button, Heading, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { DateFormat } from "constants/date";
import { isInIframe } from "helpers/app";
import { formatPrice } from "helpers/subscription";
import { AgentsRoutes } from "routes/agents/constants";
import { textEllipsisStylesWithWrap } from "styles/common";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

import { ButtonsWrapper } from "../styled";

interface IProps {
  invoiceEmail: string;
  isTaxed: boolean;
  spareAgents: number;
  newPrice: number | null;
  nextInvoiceDate: Date | null;
}

export const NextPayment: React.FC<IProps> = ({ invoiceEmail, isTaxed, newPrice, nextInvoiceDate, spareAgents }) => {
  const history = useHistory();
  const inIframe = isInIframe();

  return (
    <>
      <Flex column gap={withVar(SpacingToken.Spacing4)}>
        <Heading size="lg">Your subscription has been updated!</Heading>
        <Text css={textEllipsisStylesWithWrap}>
          The invoice has been sent to <b>{invoiceEmail}</b>.
          <br />
          The next one for{" "}
          <b>
            {newPrice && formatPrice(newPrice)}
            {isTaxed && " + applicable tax"}
          </b>{" "}
          {/* @ts-expect-error TS(2345) */}
          will be issued on <b>{format(nextInvoiceDate, DateFormat.DateWithoutDayOfTheWeek)}</b>.
        </Text>
        {spareAgents > 0 && (
          <Text>
            You can now invite{" "}
            <b>
              {spareAgents} more {plural(spareAgents, "Agent", "Agents")}
            </b>
            .
          </Text>
        )}
      </Flex>
      <ButtonsWrapper>
        {inIframe && (
          <Button kind="primary" onClick={() => history.push("/")}>
            Go to HelpDesk
          </Button>
        )}
        {!inIframe && (
          <Flex gap={withVar(SpacingToken.Spacing2)} flexWrap justifyContent="center">
            <Button kind="secondary" onClick={() => history.push(SubscriptionRoutes.Plans)}>
              Open my subscription
            </Button>
            <Button kind="primary" onClick={() => history.push(AgentsRoutes.AddAgent)}>
              Invite Agents
            </Button>
          </Flex>
        )}
      </ButtonsWrapper>
    </>
  );
};
